/**
 * Injected once per document. The invest app renders its own dialog chrome
 * (backdrop, modal / bottom sheet) inside the transparent full-viewport
 * iframe, so this stylesheet only covers what the SDK still paints itself:
 * the iframe's fade-in on ready and the handshake-failure fallback panel
 * (with its own dim overlay). Motion only runs under
 * `prefers-reduced-motion: no-preference`.
 */

const STYLE_ATTRIBUTE = 'data-cesto-invest-styles';

const DIALOG_CSS = `
.cesto-invest-fallback-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 2147483000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cesto-invest-panel {
  width: 320px;
  max-width: calc(100vw - 32px);
  padding: 24px;
  border-radius: 12px;
  background: #ffffff;
  color: #111827;
  font-family: system-ui, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
}
.cesto-invest-panel-message {
  margin: 0;
}
.cesto-invest-panel-continue {
  display: block;
  width: 100%;
  margin-top: 16px;
  padding: 10px 16px;
  border: 0;
  border-radius: 8px;
  background: #111827;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
}
.cesto-invest-panel-dismiss {
  display: block;
  margin: 12px auto 0;
  padding: 0;
  border: 0;
  background: none;
  color: #6b7280;
  font-size: 13px;
  text-decoration: underline;
  cursor: pointer;
}
@media (prefers-reduced-motion: no-preference) {
  .cesto-invest-frame {
    transition: opacity 160ms ease-out;
  }
  .cesto-invest-fallback-overlay {
    animation: cesto-invest-fade-in 160ms ease-out;
  }
}
@keyframes cesto-invest-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}
`;

/** Appends the dialog stylesheet to `<head>` once; later calls are no-ops. */
export function ensureDialogStyles(): void {
  if (document.head.querySelector(`style[${STYLE_ATTRIBUTE}]`)) return;
  const style = document.createElement('style');
  style.setAttribute(STYLE_ATTRIBUTE, '');
  style.textContent = DIALOG_CSS;
  document.head.appendChild(style);
}
